
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/volunteer-ex",
      function () {
        return require("private-next-pages/cases/volunteer-ex/index.tsx");
      }
    ]);
  